"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _core = require("@popperjs/core");
var _framerMotion = require("framer-motion");
var _shared = require("../../utils/shared.utils");
var _HBPopover = require("../HBPopover/HBPopover.styles");
var _HBPopover2 = require("./HBPopover.types");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _HBPopoverActions = _interopRequireDefault(require("./HBPopoverActions"));
var _useResizeObserver = require("../common/useResizeObserver");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != (0, _typeof2["default"])(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// lazy is needed to avoid circular dependency because the close button has a tooltip that uses the popover
var HBCloseButton = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../HBCloseButton/HBCloseButton'));
  });
});
var ARROW_PADDING = 10;
var getPopperConfig = function getPopperConfig(placement, withArrow, arrowRef, offsetX, offsetY, openOnMousePosition) {
  var config = {
    placement: placement,
    modifiers: []
  };
  if (withArrow) {
    config.modifiers.push({
      name: 'arrow',
      options: {
        element: arrowRef.current
      }
    }, {
      name: 'offset',
      options: {
        offset: placement === 'top' || placement === 'bottom' ? [offsetX, offsetY + ARROW_PADDING] : [offsetY, offsetX]
      }
    }, {
      name: 'hide'
    });
  } else {
    config.modifiers.push({
      name: 'offset',
      options: {
        offset: placement === 'top' || placement === 'bottom' ? [offsetX, offsetY] : [offsetY, offsetX]
      }
    });
  }

  // add preventOverflow modifier for mouse position
  if (openOnMousePosition) {
    config.modifiers.push({
      name: 'preventOverflow',
      options: {
        boundary: 'viewport'
      }
    });
  }
  return config;
};
function usePopover(_ref) {
  var enableInitialOpen = _ref.enableInitialOpen,
    openTrigger = _ref.openTrigger,
    placement = _ref.placement,
    offsetX = _ref.offsetX,
    offsetY = _ref.offsetY,
    withArrow = _ref.withArrow,
    shouldSupportClickOutside = _ref.shouldSupportClickOutside,
    shouldSupportCloseOnEnter = _ref.shouldSupportCloseOnEnter,
    stopPropagationOnTargetClick = _ref.stopPropagationOnTargetClick,
    keepOpenOnHover = _ref.keepOpenOnHover,
    onOpenChange = _ref.onOpenChange,
    forceClose = _ref.forceClose,
    forceOpen = _ref.forceOpen,
    keepOpenWhileTyping = _ref.keepOpenWhileTyping,
    children = _ref.children,
    openOnFocus = _ref.openOnFocus,
    openOnMousePositionProp = _ref.openOnMousePosition;
  var popoverRef = (0, _react.useRef)(null);
  var arrowRef = (0, _react.useRef)(null);
  var targetRef = (0, _react.useRef)(null);
  var popoverInstance = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    targetIsFocus = _useState2[0],
    setTargetIsFocus = _useState2[1];
  var virtualElementRef = (0, _react.useRef)(null);
  var openOnMousePosition = openOnMousePositionProp && openTrigger === 'click';
  var shouldOpen = !forceClose && (0, _shared.isReactChildrenHasContent)(children);
  // We assume here that if the user doesn't send any openTrigger
  // it means that he wants the popover to be always open.
  // In case we want to set the initial open state of the popover we can use the prop 'enableInitialOpen'.
  // This prop will set the popover open only for the initial render.
  var _useState3 = (0, _react.useState)(enableInitialOpen || shouldOpen && !openTrigger),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    _isOpen = _useState4[0],
    _setIsOpen = _useState4[1];
  var isOpen = shouldOpen && (_isOpen || forceOpen);

  // onOpenChange should be triggered whenever _setIsOpen is called
  var setIsOpen = (0, _react.useCallback)(function (_ref2) {
    var newIsOpen = _ref2.newIsOpen,
      triggeredFrom = _ref2.triggeredFrom;
    _setIsOpen(newIsOpen);
    onOpenChange === null || onOpenChange === void 0 || onOpenChange({
      isOpen: newIsOpen,
      triggeredFrom: triggeredFrom
    });
  }, [onOpenChange]);
  var handleDocumentClick = (0, _react.useCallback)(function (e) {
    var _targetRef$current, _popoverRef$current;
    if (!((_targetRef$current = targetRef.current) !== null && _targetRef$current !== void 0 && _targetRef$current.contains(e.target)) && !((_popoverRef$current = popoverRef.current) !== null && _popoverRef$current !== void 0 && _popoverRef$current.contains(e.target))) {
      setIsOpen({
        newIsOpen: false,
        triggeredFrom: _HBPopover2.HBPopoverOnOpenChangeTrigger.ClickOutside
      });
    }
  }, [setIsOpen, targetRef, popoverRef]);
  var handleKeypress = (0, _react.useCallback)(function (e) {
    if (e.key === 'Enter') {
      setIsOpen({
        newIsOpen: false,
        triggeredFrom: _HBPopover2.HBPopoverOnOpenChangeTrigger.EnterKey
      });
    }
  }, [setIsOpen]);

  // virtual element for mouse position when openOnMousePosition is true
  var createVirtualElement = (0, _react.useCallback)(function (x, y) {
    return {
      getBoundingClientRect: function getBoundingClientRect() {
        return {
          width: 0,
          height: 0,
          top: y,
          right: x,
          bottom: y,
          left: x
        };
      }
    };
  }, []);

  // create popper
  (0, _react.useLayoutEffect)(function () {
    var referenceElement = openOnMousePosition ? virtualElementRef.current : targetRef.current;
    if (popoverRef !== null && popoverRef !== void 0 && popoverRef.current && referenceElement && isOpen) {
      popoverInstance.current = (0, _core.createPopper)(referenceElement, popoverRef.current, getPopperConfig(placement, withArrow, arrowRef, offsetX, offsetY, openOnMousePosition));
    }
  }, [placement, withArrow, isOpen, offsetX, offsetY, openOnMousePosition]);
  var updatePopover = function updatePopover() {
    var _popoverInstance$curr;
    return (_popoverInstance$curr = popoverInstance.current) === null || _popoverInstance$curr === void 0 ? void 0 : _popoverInstance$curr.update();
  };

  // update popover position when popover sizes change, i.e. when images load
  (0, _useResizeObserver.useResizeObserver)(popoverRef, updatePopover);
  (0, _react.useEffect)(updatePopover, [children]);

  // support click outside
  var currentPopoverRef = popoverRef.current;
  (0, _react.useEffect)(function () {
    var events = ['mousedown', 'touchstart'];
    if (isOpen && shouldSupportClickOutside) {
      events.forEach(function (event) {
        document.addEventListener(event, handleDocumentClick, true);
      });
      return function () {
        events.forEach(function (event) {
          document.removeEventListener(event, handleDocumentClick, true);
        });
      };
    }
  }, [currentPopoverRef, handleDocumentClick, isOpen, shouldSupportClickOutside]);

  // support close on enter
  (0, _react.useEffect)(function () {
    if (isOpen && shouldSupportCloseOnEnter) {
      document.addEventListener('keypress', handleKeypress);
      return function () {
        document.removeEventListener('keypress', handleKeypress);
      };
    }
  }, [handleKeypress, isOpen, shouldSupportCloseOnEnter]);

  // Init isOpen to false when shouldOpen becomes false
  (0, _react.useEffect)(function () {
    if (!shouldOpen) {
      setIsOpen({
        newIsOpen: false
      });
    }
  }, [shouldOpen, setIsOpen]);
  var triggerConfig = {};
  var popoverTriggerConfig = {};
  if (openTrigger === 'click') {
    triggerConfig.onClick = function (ev) {
      if (stopPropagationOnTargetClick) {
        ev.stopPropagation();
      }
      if (openOnMousePosition) {
        virtualElementRef.current = createVirtualElement(ev.clientX, ev.clientY);
      }
      setIsOpen({
        newIsOpen: !isOpen,
        triggeredFrom: _HBPopover2.HBPopoverOnOpenChangeTrigger.TargetClick
      });
    };
    if (keepOpenWhileTyping) {
      triggerConfig.onKeyDown = function () {
        if (!isOpen) {
          setIsOpen({
            newIsOpen: true
          });
        }
      };
    }
  } else if (openTrigger === 'hover') {
    triggerConfig.onMouseOver = function () {
      if (!isOpen) {
        setIsOpen({
          newIsOpen: true
        });
      }
    };
    triggerConfig.onMouseLeave = function () {
      if (!openOnFocus || !targetIsFocus) {
        setIsOpen({
          newIsOpen: false
        });
      }
    };
    if (openOnFocus) {
      triggerConfig.onFocus = function () {
        setTargetIsFocus(true);
        if (!isOpen) {
          setIsOpen({
            newIsOpen: true
          });
        }
      };
      triggerConfig.onBlur = function () {
        setTargetIsFocus(false);
        setIsOpen({
          newIsOpen: false
        });
      };
    }
    if (keepOpenOnHover) {
      popoverTriggerConfig.onMouseOver = function () {
        setIsOpen({
          newIsOpen: true
        });
      };
      popoverTriggerConfig.onMouseLeave = function () {
        setIsOpen({
          newIsOpen: false
        });
      };
    }
  }
  return {
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    targetRef: targetRef,
    popoverRef: popoverRef,
    arrowRef: arrowRef,
    triggerConfig: triggerConfig,
    popoverTriggerConfig: popoverTriggerConfig
  };
}
var HBPopover = function HBPopover(_ref3) {
  var enableInitialOpen = _ref3.enableInitialOpen,
    testIdName = _ref3.testIdName,
    testId = _ref3.testId,
    actions = _ref3.actions,
    actionsAlignment = _ref3.actionsAlignment,
    children = _ref3.children,
    className = _ref3.className,
    customStyle = _ref3.customStyle,
    delayShowInMs = _ref3.delayShowInMs,
    _ref3$keepOpenOnHover = _ref3.keepOpenOnHover,
    keepOpenOnHover = _ref3$keepOpenOnHover === void 0 ? true : _ref3$keepOpenOnHover,
    _ref3$forceClose = _ref3.forceClose,
    forceClose = _ref3$forceClose === void 0 ? false : _ref3$forceClose,
    _ref3$forceOpen = _ref3.forceOpen,
    forceOpen = _ref3$forceOpen === void 0 ? false : _ref3$forceOpen,
    _ref3$shouldNotPropag = _ref3.shouldNotPropagateMouseOverEvent,
    shouldNotPropagateMouseOverEvent = _ref3$shouldNotPropag === void 0 ? false : _ref3$shouldNotPropag,
    keepOpenWhileTyping = _ref3.keepOpenWhileTyping,
    _ref3$offsetX = _ref3.offsetX,
    offsetX = _ref3$offsetX === void 0 ? 0 : _ref3$offsetX,
    _ref3$offsetY = _ref3.offsetY,
    offsetY = _ref3$offsetY === void 0 ? 0 : _ref3$offsetY,
    _ref3$onOpenChange = _ref3.onOpenChange,
    onOpenChange = _ref3$onOpenChange === void 0 ? function () {} : _ref3$onOpenChange,
    openTrigger = _ref3.openTrigger,
    _ref3$placement = _ref3.placement,
    placement = _ref3$placement === void 0 ? 'bottom' : _ref3$placement,
    shouldSupportClickOutside = _ref3.shouldSupportClickOutside,
    shouldSupportCloseOnEnter = _ref3.shouldSupportCloseOnEnter,
    shouldSupportOverflowHidden = _ref3.shouldSupportOverflowHidden,
    isTargetContainerFocusable = _ref3.isTargetContainerFocusable,
    stopPropagationOnTargetClick = _ref3.stopPropagationOnTargetClick,
    stopPropagationOnPopoverClick = _ref3.stopPropagationOnPopoverClick,
    target = _ref3.target,
    targetContainerClassName = _ref3.targetContainerClassName,
    _ref3$targetContainer = _ref3.targetContainerStyle,
    targetContainerStyle = _ref3$targetContainer === void 0 ? {} : _ref3$targetContainer,
    _ref3$theme = _ref3.theme,
    theme = _ref3$theme === void 0 ? 'popover' : _ref3$theme,
    withArrow = _ref3.withArrow,
    _ref3$withCloseButton = _ref3.withCloseButton,
    withCloseButton = _ref3$withCloseButton === void 0 ? false : _ref3$withCloseButton,
    openOnFocus = _ref3.openOnFocus,
    onExitComplete = _ref3.onExitComplete,
    role = _ref3.role,
    maxWidth = _ref3.maxWidth,
    variants = _ref3.variants,
    openOnMousePosition = _ref3.openOnMousePosition;
  var _usePopover = usePopover({
      enableInitialOpen: enableInitialOpen,
      openTrigger: openTrigger,
      placement: placement,
      offsetX: offsetX,
      offsetY: offsetY,
      withArrow: withArrow,
      shouldSupportClickOutside: shouldSupportClickOutside,
      shouldSupportCloseOnEnter: shouldSupportCloseOnEnter,
      keepOpenOnHover: keepOpenOnHover,
      stopPropagationOnTargetClick: stopPropagationOnTargetClick,
      stopPropagationOnPopoverClick: stopPropagationOnPopoverClick,
      onOpenChange: onOpenChange,
      forceClose: forceClose,
      forceOpen: forceOpen,
      keepOpenWhileTyping: keepOpenWhileTyping,
      children: children,
      openOnFocus: openOnFocus,
      openOnMousePosition: openOnMousePosition
    }),
    isOpen = _usePopover.isOpen,
    triggerConfig = _usePopover.triggerConfig,
    popoverTriggerConfig = _usePopover.popoverTriggerConfig,
    targetRef = _usePopover.targetRef,
    popoverRef = _usePopover.popoverRef,
    arrowRef = _usePopover.arrowRef,
    setIsOpen = _usePopover.setIsOpen;
  var transformedChildren = typeof children === 'function' ? children(setIsOpen, isOpen) : children;
  var transformedTarget = typeof target === 'function' ? target(isOpen) : target;
  var showingOpacity = customStyle !== null && customStyle !== void 0 && customStyle.opacity ? customStyle.opacity : 1;
  var stopPropagatingMouseOver = function stopPropagatingMouseOver(ev) {
    ev.stopPropagation();
  };
  var onClick = function onClick(ev) {
    if (stopPropagationOnPopoverClick) {
      ev.stopPropagation();
    }
  };
  var onKeyDown = function onKeyDown(ev) {
    if (stopPropagationOnPopoverClick) {
      ev.stopPropagation();
    }
  };
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'popover',
    componentName: 'HBPopover'
  });
  var defaultVariants = (0, _react.useMemo)(function () {
    return {
      hidden: {
        opacity: 0,
        transition: {
          duration: 0.2
        }
      },
      visible: {
        opacity: showingOpacity,
        transition: {
          duration: 0.2,
          delay: (delayShowInMs || 0) / 1000
        }
      }
    };
  }, [delayShowInMs, showingOpacity]);
  var finalVariants = variants || defaultVariants;
  var popover = /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, {
    onExitComplete: onExitComplete
  }, isOpen && /*#__PURE__*/_react["default"].createElement(_HBPopover.Popover, (0, _extends2["default"])({
    className: className,
    ref: popoverRef,
    onMouseOver: shouldNotPropagateMouseOverEvent ? stopPropagatingMouseOver : undefined,
    onClick: onClick,
    onKeyDown: onKeyDown,
    theme: theme,
    style: customStyle,
    $isOpen: isOpen
  }, popoverTriggerConfig, {
    initial: "hidden",
    animate: "visible",
    exit: "hidden",
    variants: finalVariants,
    role: role,
    $offsetX: offsetX,
    $offsetY: offsetY,
    $keepOpenOnHover: keepOpenOnHover,
    $maxWidth: maxWidth
  }), transformedChildren, actions && /*#__PURE__*/_react["default"].createElement(_HBPopoverActions["default"], {
    actionsAlignment: actionsAlignment,
    actions: actions,
    clickCallback: setIsOpen,
    marginTop: 16
  }), withArrow && /*#__PURE__*/_react["default"].createElement(_HBPopover.Arrow, {
    ref: arrowRef,
    "data-popper-arrow": true,
    theme: theme
  }), withCloseButton && /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)
  }, /*#__PURE__*/_react["default"].createElement(HBCloseButton, {
    distance: 8,
    size: "xs",
    theme: "dark",
    testIdName: finalTestId,
    onClick: function onClick() {
      return setIsOpen({
        newIsOpen: false
      });
    }
  }))));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_HBPopover.TargetContainer, (0, _extends2["default"])({
    "data-popover-state": isOpen ? 'open' : 'closed',
    ref: targetRef
  }, triggerConfig, {
    style: targetContainerStyle,
    className: targetContainerClassName,
    tabIndex: isTargetContainerFocusable ? 0 : undefined,
    "data-testid": finalTestId ? "".concat(finalTestId, "-button") : undefined
  }), transformedTarget), shouldSupportOverflowHidden ? /*#__PURE__*/(0, _reactDom.createPortal)(popover, document.querySelector('body')) : popover);
};
var _default = exports["default"] = HBPopover;
//# sourceMappingURL=HBPopover.js.map